module.exports = __webpack_public_path__ + "static-portal/img/62-2.8d2982b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/yingyong/62-2.jpg
// module id = ynSl
// module chunks = 4